import React from "react";
import { Sensors } from "@mui/icons-material";

export const getMotionIcon = (widget = null) => {
  const iconProps = {
    style: {
      fontSize: "1.5rem",
      paddingBottom: "2px",
    },
  };
  return <Sensors {...iconProps} />;
};

export const getMotionSubtitle = (widget = null) => {
  if (!widget) return "";
  const hasMotion = widget?.items?.$w1?.value === "motion";
  return hasMotion ? "Motion" : "Clear";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getMotionPatterns = () => {
  return ["basic.device.motion"];
};
